import { useCallback, useEffect, useState } from "react";
import { saasApi } from "../api/saasApi";
import { isAdminLoggedIn } from "../utils/session";

export function useSubscription() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    if (!isAdminLoggedIn()) {
      setData(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const res = await saasApi.getSubscription();
      setData(res.data);
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { data, loading, error, refresh };
}
